(function () {
  'use strict';

  angular.module('ringbaPortal').component('callDetailsPanel', {
    bindings: {
      callId: '<',
      callDate: '<'
    },
    controller: CallDetailsPanelController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/call-details-panel/call-details-panel.view.html'
  });

  function CallDetailsPanelController(
    $filter,
    accountsService,
    callLogsService,
    reportingService,
    dateTimeService
  ) {
    'ngInject';

    const vm = this;

    const callProperties = [
      {
        property: 'callDt',
        filter: _dateFilter,
        displayHeader: $filter('translate')('CALL_DATE_HEADER_TASK_CALL')
      },
      {
        property: 'campaignName',
        link: 'campaignId',
        linkState: 'dashboard.campaign',
        linkParam: 'campaignId',
        displayHeader: $filter('translate')('CAMPAIGN_HEADER_TASK_CALL')
      },
      {
        property: 'inboundPhoneNumber',
        displayHeader: $filter('translate')('CALLER_HEADER_TASK_CALL')
      },
      {
        property: 'buyer',
        displayHeader: $filter('translate')('BUYER_HEADER_TASK_CALL')
      },
      {
        property: 'targetName',
        link: 'targetId',
        linkState: 'dashboard.target.edit',
        linkParam: 'targetId',
        displayHeader: $filter('translate')('TARGET_HEADER_TASK_CALL')
      },
      {
        property: 'conversionAmount',
        filter: _currencyFilter,
        class: 'text-right',
        displayHeader: $filter('translate')('CONVERSION_HEADER_TASK_CALL')
      },
      {
        property: 'publisherName',
        link: 'publisherId',
        linkState: 'dashboard.affiliate.edit',
        linkParam: 'affiliateId',
        displayHeader: $filter('translate')('PUBLISHER_HEADER_TASK_CALL')
      },
      {
        property: 'payoutAmount',
        filter: _currencyFilter,
        class: 'text-right',
        displayHeader: $filter('translate')('PAYOUT_HEADER_TASK_CALL')
      },
      {
        property: 'callLengthInSeconds',
        class: 'text-right',
        displayHeader: $filter('translate')('CALL_LENGTH_HEADER_TASK_CALL')
      },
      {
        property: 'recordingUrl',
        extraDataToBind: 'inboundPhoneNumber',
        displayHeader: $filter('translate')('RECORDING_HEADER_TASK_CALL')
      }
    ];

    vm.$onInit = onInit;

    function onInit() {
      vm.loading = true;
      _loadCallDetails();
    }

    function _setDataToBeShownFromDetails(callData) {
      vm.showData = [];
      const keys = Object.keys(callData);
      _.forEach(callProperties, function (propertyFound) {
        if (_.includes(keys, propertyFound.property)) {
          const column = {
            original: callData[propertyFound.property],
            name: propertyFound.property,
          };
          const data = {
            original: column.original,
            name: column.name,
            displayHeader: propertyFound.displayHeader,
            class: propertyFound.class
          };
          if (propertyFound.link) {
            data.linkState = propertyFound.linkState;
            data.linkParams = { [propertyFound.linkParam]: callData[propertyFound.link] };
          }
          if (propertyFound.filter) {
            data.original = propertyFound.filter(column);
          }
          if (propertyFound.extraDataToBind) {
            column[propertyFound.extraDataToBind] = propertyFound.extraDataToBind;
            data[propertyFound.extraDataToBind] = column[propertyFound.extraDataToBind];
          }
          vm.showData.push(data);
        }
      });
    }

    function _dateFilter(column) {
      return $filter('utcToLocal')(column.original, 'MMM d, y h:mm a');
    }

    function _currencyFilter(column) {
      return $filter('currency')(column.original, '$', 2);
    }

    function _loadCallDetails() {
      reportingService.getCallDetails(accountsService.currentAccountId, {
        inboundCallIds: [vm.callId],
        formatTimespans: true,
        formatPercentages: true,
        formatDateTime: true,
        formatTimeZone: dateTimeService.getTimeZoneForBackend(accountsService.currentAccount.timeZoneId),
      }).then(function (response) {
        vm.callData = response;
        return _resolveRecordingTempUrl(vm.callData);
      }).then(function () {
        vm.loading = false;
        _setDataToBeShownFromDetails(vm.callData);
      });
    }

    // Recordings are moving behind authentication: exchange the call's recording key
    // for a short-lived temp URL before the columns render (the recording column is
    // one-time bound). The reported legacy URL stays as the fallback.
    function _resolveRecordingTempUrl(callData) {
      const recordingKey = reportingService.getRecordingKeyFromCallDetails(callData);

      if (!recordingKey) {
        return;
      }

      return reportingService.getRecordingTempUrl(accountsService.currentAccountId, recordingKey)
        .then(function (tempUrl) {
          callData.recordingUrl = tempUrl;
        })
        .catch(function () {
          // Minting failed — keep whatever recordingUrl the report provided
        });
    }

  }
})();
